var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectStreamBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1608.768,
    height: 851.494,
    viewBox: "0 0 1608.768 851.494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44435",
    "data-name": "Group 44435",
    transform: "translate(-704.224 -417.918)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 88.776,
    cy: 88.776,
    r: 88.776,
    transform: "translate(2135.439 447.154)",
    fill: "#c5c5ff",
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    transform: "translate(2016.107 1190.215)",
    fill: "none",
    stroke: "#c5c5ff",
    strokeWidth: 9,
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.237,
    cy: 39.598,
    rx: 40.237,
    ry: 39.598,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.237,
    cy: 39.598,
    rx: 35.737,
    ry: 35.098,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    transform: "translate(704.224 417.918)",
    fill: "none",
    stroke: "#c5c5ff",
    strokeWidth: 9
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.598,
    cy: 40.237,
    rx: 39.598,
    ry: 40.237,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.598,
    cy: 40.237,
    rx: 35.098,
    ry: 35.737,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectStreamBack);
export default __webpack_public_path__ + "static/media/selectStreamBack.053a3b6f7347336755d8d0a4a0c6e09c.svg";
export { ForwardRef as ReactComponent };